var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.096,5.389l-3.485-3.485c-1.228-1.228-2.86-1.904-4.596-1.904H6.5C4.019,0,2,2.019,2,4.5v15c0,2.481,2.019,4.5,4.5,4.5h11c2.481,0,4.5-2.019,4.5-4.5V9.985c0-1.736-.676-3.369-1.904-4.596Zm-.707,.707c.55,.551,.965,1.199,1.238,1.904h-5.127c-.827,0-1.5-.673-1.5-1.5V1.373c.705,.273,1.353,.688,1.904,1.238l3.485,3.485Zm1.611,13.404c0,1.93-1.57,3.5-3.5,3.5H6.5c-1.93,0-3.5-1.57-3.5-3.5V4.5c0-1.93,1.57-3.5,3.5-3.5h5.515c.334,0,.663,.033,.985,.091V6.5c0,1.378,1.122,2.5,2.5,2.5h5.409c.058,.322,.091,.651,.091,.985v9.515Zm-3.746-6.356c-.461-.231-1.002-.181-1.443,.151l-.811,.711v-.506c0-.827-.673-1.5-1.5-1.5H7.5c-.827,0-1.5,.673-1.5,1.5v5c0,.827,.673,1.5,1.5,1.5h6c.827,0,1.5-.673,1.5-1.5v-.507l.84,.736c.239,.18,.522,.271,.808,.271,.206,0,.413-.047,.605-.144,.46-.23,.746-.693,.746-1.208v-3.297c0-.515-.286-.977-.746-1.208Zm-3.254,5.356c0,.276-.224,.5-.5,.5H7.5c-.276,0-.5-.224-.5-.5v-5c0-.276,.224-.5,.5-.5h6c.276,0,.5,.224,.5,.5v5Zm3-.852c0,.195-.135,.284-.193,.313-.058,.03-.21,.083-.337-.009l-1.47-1.289v-1.328l1.44-1.264c.157-.116,.309-.062,.367-.033,.058,.029,.193,.118,.193,.313v3.297Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideo);
export default __webpack_public_path__ + "static/media/file-video.31d7be8a99d06e009f5ee2a7f4704f97.svg";
export { ForwardRef as ReactComponent };